module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/sale-1-dc1ac0ee55145695c8745d84929e4f24.svg";